// extracted by mini-css-extract-plugin
module.exports = {"draggableComponent":"draggableComponent_oKfmb","toolbar":"toolbar_1uTQG","button":"button_4f5WQ"};